export default __webpack_public_path__ + "static/media/iPhone12Pro.ae1f5a4d.png";